(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("colors", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/theme/colors/colorsView.html",
            controller: ["colorService", "messageService", "$rootScope", "$scope", "_", "$timeout", ColorsCtrl],
            controllerAs: "vm"
        };
        function ColorsCtrl(colorService, messageService, $rootScope, $scope, _, $timeout) {
            var vm = this;
            vm.saving = false;
            vm.loading = true;
            vm.palette = [];
            loadPalette();
            ////////////////////////////////////////////////////
            //Loads a color palette using tenant logo.
            function loadPalette() {
                colorService.getLogoPalette().then(function (result) {
                    vm.palette = _.map(result.tenMostUsedColors, function (color) { return "rgb(" + color + ")"; });
                    var groupedItems = _.groupBy(vm.palette, function (item, i) {
                        return Math.floor(i / 2);
                    });
                    vm.palette = _.values(groupedItems);
                    loadColors();
                }, function () {
                    //If something wrong happens, show the color pickers without the palette.
                    loadColors();
                });
            }
            //Loads the color pickers
            function loadColors() {
                vm.primary = {};
                vm.primary.color = colorService.getPrimaryColor();
                vm.primary.textColor = colorService.getPrimaryTextColor();
                vm.secondary = {};
                vm.secondary.color = colorService.getSecondaryColor();
                vm.secondary.textColor = colorService.getSecondaryTextColor();
                vm.loading = false;
            }
            var siteColorChangedListener = $rootScope.$on("siteColorChanged", loadColors);
            var siteLogoChangedListener = $rootScope.$on("siteLogoChanged", loadPalette);
            this.$onDestroy = function () {
                siteColorChangedListener();
                siteLogoChangedListener();
            };
            vm.save = function () {
                vm.saving = true;
                $timeout(function () {
                    colorService.saveColors(vm.primary.color, vm.secondary.color, vm.primary.textColor, vm.secondary.textColor).then(function () {
                        messageService.success("common.changesSaved");
                        vm.saving = false;
                        //$emit send's the event to the parent controllers. Main Controller is listening for this.
                        $scope.$emit("dismissPreviewTheme");
                        $rootScope.$broadcast("closePreviewAngularTheme", { resetA2Colors: false }); //closes A2 PNB
                    }, function () {
                        messageService.error("common.genericError");
                        vm.saving = false;
                    });
                });
            };
            vm.preview = function () {
                colorService.previewSiteColors(vm.primary.color, vm.secondary.color, vm.primary.textColor, vm.secondary.textColor);
                $scope.$emit("previewTheme");
            };
        }
    });
}());
